import { ErrorDetailMessage } from "@context-providers/error-boundary/error-detail-message";
import { useToast } from "@flat-ui";
import { removeOne } from "@store/errors/errors-slice";
import { useAppDispatch } from "@store/store-helper";
import { useEffect } from "react";
/**
 * Displays an error message in a toast on the top-center of the screen.
 * This component needs to call some hooks (useToast, useAppDispatch). It should either be a React component or a hook.
 * As it is called inside ErrorBoundary class component, converting it to hook will not work.
 * So, it needs to return JSX.Element and an empty fragment as the simplest option
 */
export function ErrorToast({
  error,
  onClose
}) {
  const dispatch = useAppDispatch();
  const {
    openToast
  } = useToast();
  useEffect(() => {
    function onCloseHandler() {
      dispatch(removeOne(error.id));
      onClose();
    }
    openToast({
      title: error.title,
      message: <div style={{
        marginTop: "8px"
      }}>
          <ErrorDetailMessage error={error.error} />
        </div>,
      variant: "error",
      onClose: onCloseHandler
    });
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps -- We want to show the toast exactly once.
  }, []);

  // eslint-disable-next-line react/jsx-no-useless-fragment -- Should return <> to satisfy JSX.Element return type
  return <></>;
}